import { useState, useEffect } from "react";
import { apiFetch } from "../../helpers";

const CATEGORIES = [
  "All",
  "Clinic",
  "Treatments",
  "Team",
  "Before & After",
  "Events",
];

export default function GallerySection() {
  const [gallery, setGallery] = useState([]);
  const [active, setActive] = useState("All");
  const [lightbox, setLightbox] = useState(null);
  const [loading, setLoading] = useState(true);

  const imageUrl = (img) => {
    if (!img) return "";

    const clean = img.replace(/\\/g, "/").trim();

    const baseUrl = process.env.REACT_APP_WEB_URL;

    return `${baseUrl}/${clean.replace(/^\/+/, "")}`;
  };

  const fetchGallery = async () => {
    setLoading(true);

    try {
      const json = await apiFetch(`${process.env.REACT_APP_GALLERY_VIEW}`);

      if (json.status) {
        setGallery(json.data || []);
      } else {
        setGallery([]);
      }
    } catch (e) {
      console.error(e);
      setGallery([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const filtered =
    active === "All" ? gallery : gallery.filter((i) => i.category === active);

  return (
    <section id="gallery"
      style={{
        padding: "100px 0",
        background: "#0A1628",
        minHeight: "calc(100vh - 90px)"
      }}
    >
      <div
        style={{
          padding: 33,
        }}
      ></div>
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 1.5rem",
        }}
      >
        <h2
          style={{
            color: "#fff",
            fontSize: 36,
            fontWeight: 800,
            marginBottom: 20,
          }}
        >
          Our Gallery
        </h2>

        {/* Tabs */}
        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
            marginBottom: 24,
          }}
        >
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              style={{
                padding: "8px 16px",
                borderRadius: 20,
                border: "none",
                cursor: "pointer",
                background: active === cat ? "#1D9E75" : "#162850",
                color: "#fff",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        {loading ? (
          <p style={{ color: "#fff" }}>Loading...</p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill,minmax(250px,1fr))",
              gap: 16,
            }}
          >
            {filtered.map((item) => (
              <div
                key={item.gallery_id}
                onClick={() => setLightbox(item)}
                style={{
                  background: "#162850",
                  borderRadius: 14,
                  overflow: "hidden",
                  cursor: "pointer",
                }}
              >
                <img
                  src={imageUrl(item.image)}
                  alt={item.title}
                  style={{
                    width: "100%",
                    height: 220,
                    objectFit: "cover",
                  }}
                />

                <div style={{ padding: 12 }}>
                  <div
                    style={{
                      color: "#fff",
                      fontWeight: 700,
                    }}
                  >
                    {item.title}
                  </div>

                  <div
                    style={{
                      color: "rgba(255,255,255,.6)",
                      fontSize: 13,
                    }}
                  >
                    {item.category}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.8)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 14,
              maxWidth: 700,
              width: "90%",
              overflow: "hidden",
            }}
          >
            <img
              src={imageUrl(lightbox.image)}
              alt={lightbox.title}
              style={{
                width: "100%",
                maxHeight: 500,
                objectFit: "cover",
              }}
            />

            <div style={{ padding: 16 }}>
              <h3>{lightbox.title}</h3>
              <p>{lightbox.category}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
